export default __webpack_public_path__ + "static/media/maxcare.104a1242.png";